export default __webpack_public_path__ + "static/media/pr_c_03.fd6c445e.jpg";